// extracted by mini-css-extract-plugin
module.exports = {"detailsGrid":"InvestmentDetails_detailsGrid__1Ol3u","fancyPoint":"InvestmentDetails_fancyPoint__2-5P6"};